import { render, staticRenderFns } from "./Time.vue?vue&type=template&id=70050570&scoped=true"
import script from "./Time.vue?vue&type=script&lang=js"
export * from "./Time.vue?vue&type=script&lang=js"
import style0 from "./Time.vue?vue&type=style&index=0&id=70050570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70050570",
  null
  
)

export default component.exports